<div>
  <h1>Asset Import History</h1>
  @if (!deleting) {
    <div>
      <p-table [value]="assetImports" [alwaysShowPaginator]="false" [paginator]="showPaginator(assetImports)" [pageLinks]="5" [rows]="rowsPerPage"
        styleClass="shadow" sortField="created_at" sortOrder="-1">
        <ng-template pTemplate="header">
          <tr>
            <th>{{(franchise) ? customFieldNames ? customFieldNames.project_id : 'Project' : 'Warehouse'}}</th>
            <th>Date & Time</th>
            <th>Uploaded By</th>
            <th>Assets Created</th>
            <th>Assets Accepted</th>
            <th>Assets For Review</th>
            <th>Deleted</th>
            <th>Deleted On</th>
            <th>Deleted By</th>
            <th>File</th>
            <th class="ah-col-button"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ai>
          <tr>
            <td>{{(franchise) ? ai.project.name : ai.warehouse.name}}</td>
            <td>{{moment.utc(ai.created_at).local().format('DD MMM. YYYY, h:mm:ss a')}}</td>
            <td>{{userLookup[ai.created_by]?.fullName()}}</td>
            <td>{{ ai | getAssetCount }}</td>
            <td>{{ ai | getAcceptedAssetsCount }}</td>
            <td>{{ ai | getForReviewAssetsCount }}</td>
            <td>{{ ai.deleted?'Yes':'No' }}</td>
            <td>{{ ai.deleted ? moment.utc(ai?.deleted_at).local().format('DD MMM. YYYY, h:mm:ss a') : ''}}</td>
            <td>{{ai.deleted?userLookup[ai.deleted_by]?.fullName():''}}</td>
            <td>
              <a href={{ai?.link}}>
              {{ai?.original_filename}}</a>
            </td>
            <td class="ah-col-button">
              @if (!ai.deleted) {
                <mat-icon class="clickable" (click)="removeAssetImport(ai)" svgIcon="delete"></mat-icon>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td [attr.colspan]="3">Summary:</td>
            <td>{{ assetImports | getAssetsTotal }}</td>
            <td>{{ assetImports | getAcceptedAssetsTotal }}</td>
            <td>{{ assetImports | getForReviewAssetsTotal }}</td>
            <td [attr.colspan]="5"></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
  @if (deleting) {
    <div class="flex-column space-center center" style="height: 100%;">
      <mat-card appearance="outlined">
        <div>
          <h1>Deleting Asset Import...</h1>
          <p style="margin-left: 25px;">Please wait, this may take a few minutes</p>
        </div>
        <div>
          <mat-spinner style="margin: 0 auto"></mat-spinner>
        </div>
      </mat-card>
    </div>
  }
</div>
